import { useMutation } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { genomeApi } from '~/shared/services/api';

type UsePatchPreferredLanguageOptions = {
  onSuccess?: (
    data: AxiosResponse<{ genomePreferredLanguage: string }>
  ) => void;
  onError?: (error: Error) => void;
};

function patchPreferredLanguage({
  preferredLanguage,
}: {
  preferredLanguage: string;
}) {
  return genomeApi.patch<{ genomePreferredLanguage: string }>(
    'employee/preferred-language',
    { preferredLanguage }
  );
}

export function usePatchPreferredLanguage({
  onSuccess,
  onError,
}: UsePatchPreferredLanguageOptions = {}) {
  return useMutation({
    mutationFn: patchPreferredLanguage,
    onSuccess,
    onError,
  });
}
